import { useTranslation } from 'react-i18next';
import { InfluencerPostSection, InfluencerNewProfileHeaderV2 } from '@anytag/graphql';
import {
  likePinkImage,
  chatGreenImage,
  videoPinkImage,
  networkBlueImage,
  chartLightYellowImage
} from '@anytag/shared-assets';
import { ChartsContainer } from '@anytag/shared-atoms';
import { PostingHabits, AverageEngagement } from '@anytag/shared-molecules';
import { useInfluencerProfileOpacityContent } from '../../../hooks';
import { InfluencerSelectedAccountInfo } from '../../../types';
import { InfluencerProfilePostsOverviewWrapper } from '../../shared';

interface InfluencerTwitterProfilePostsOverviewProps {
  data?: InfluencerPostSection;
  socialAccount: InfluencerSelectedAccountInfo;
  influencerProfile: InfluencerNewProfileHeaderV2;
}

export const InfluencerTwitterProfilePostsOverview = ({
  data,
  socialAccount,
  influencerProfile: { id }
}: InfluencerTwitterProfilePostsOverviewProps) => {
  const { t } = useTranslation();
  const { opacityContent } = useInfluencerProfileOpacityContent({
    socialAccount,
    influencerId: id,
    skipEstimateContent: true
  });

  return (
    <InfluencerProfilePostsOverviewWrapper data={data}>
      <ChartsContainer
        css={{ height: '324px' }}
        elements={[
          <AverageEngagement
            data={[
              {
                icon: videoPinkImage,
                label: t('Avg posts/week'),
                value: data?.averagePostsPerWeek || null
              },
              {
                isPercentage: true,
                icon: chartLightYellowImage,
                value: data?.engagementFollowersRate || null,
                label: t('HeaderColumn.Avg ER')
              },
              {
                icon: likePinkImage,
                value: data?.averageLikes || null,
                label: t('Avg Likes')
              },
              {
                icon: chatGreenImage,
                value: data?.averageComments || null,
                label: t('Avg Reply')
              },
              {
                icon: networkBlueImage,
                value: data?.averageShares || null,
                label: t('Avg Retweet')
              }
            ]}
          />,
          <PostingHabits {...opacityContent} data={data?.postsHabit} />
        ]}
      />
    </InfluencerProfilePostsOverviewWrapper>
  );
};
